export default __webpack_public_path__ + "static/media/juth.e66077de.png";